import { List } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const styles = {
  container: {
    overflowY: 'auto',
    height: '80vh',
    padding: 0,
  },
};
function FeedList({ children, classes, ...props }) {
  return (
    <List classes={{ root: classes.container }} {...props}>
      {children}
    </List>
  );
}

const StyledFeedList = withStyles(styles)(FeedList);

export { StyledFeedList as FeedList };
